import React from 'react'
import styled from "styled-components";
import MainNav from '../components/navbar/MainNav';

export default function PrivacyPolicy() {
  return (
    <>
      <MainNav />
      <Main>
        <div className="content">
          <h4>PRIVACY POLICY</h4>
          <p className="effective-date"><strong>Effective Date: 08/01/2025</strong></p>

          <p>
            WROOT ("we," "our," "us") is committed to protecting your privacy. This Privacy Policy explains our practices regarding data collection, usage, disclosure, and protection.
          </p>

          <h5>1. Information We Collect</h5>
          <p>
            We collect personal information necessary for providing Services, including but not limited to:
          </p>
          <ul>
            <li>Name, mailing address, email address, phone number;</li>
            <li>Payment information (processed securely through third-party payment processors);</li>
            <li>User-generated content (feedback, comments, reviews);</li>
            <li>Technical information (IP addresses, browser types, cookies).</li>
          </ul>

          <h5>2. Use of Information</h5>
          <p>
            Your personal data is collected for purposes including:
          </p>
          <ul>
            <li>Providing and managing our Services;</li>
            <li>Processing transactions and orders;</li>
            <li>Communicating with you about Services, updates, or support;</li>
            <li>Marketing and promotional activities (with your consent);</li>
            <li>Analyzing usage patterns for Service improvement.</li>
          </ul>

          <h5>3. Data Sharing and Disclosure</h5>
          <p>
            We do not sell or rent your personal information. We may share information only under these circumstances:
          </p>
          <ul>
            <li>With trusted third-party service providers necessary for delivering Services;</li>
            <li>To comply with legal obligations or enforce our Terms and Conditions;</li>
            <li>To protect our rights, safety, and those of our users and the public.</li>
          </ul>

          <h5>4. Data Security</h5>
          <p>
            We employ industry-standard security measures to protect your data against unauthorized access, misuse, or loss. However, we cannot guarantee absolute security due to inherent internet risks.
          </p>

          <h5>5. User Rights and Choices</h5>
          <p>
            You may review, update, or delete your account information at any time. You can opt-out of receiving promotional communications from us by following provided instructions.
          </p>

          <h5>6. Cookies and Tracking Technologies</h5>
          <p>
            We use cookies and similar technologies to enhance user experience and analyze traffic patterns. Users can disable cookies through browser settings, but this may affect functionality.
          </p>

          <h5>7. Children's Privacy</h5>
          <p>
            WROOT Services are not intended for individuals under 18. We do not knowingly collect or store data from children under 18. If we discover that such information has been provided, we will immediately delete it.
          </p>

          <h5>8. Changes to This Policy</h5>
          <p>
            WROOT reserves the right to update this Privacy Policy at any time. Updates will be posted on our website with an updated effective date. Continued use indicates your acceptance of changes.
          </p>

          <h5>9. Governing Law and Jurisdiction</h5>
          <p>
            This Privacy Policy shall be governed by and interpreted in accordance with the laws of the State of Nevada. You agree to resolve disputes arising under this Policy in courts located exclusively in Clark County, Nevada.
          </p>

          <h5>10. Consent</h5>
          <p>
            By using our website and Services, you explicitly consent to this Privacy Policy and the collection, usage, and disclosure practices outlined herein.
          </p>

          <h5>11. Contact Information</h5>
          <p>
            If you have any questions or concerns regarding your privacy or this Policy, please contact:
          </p>
          <ul>
            <li><strong>WROOT Privacy Support</strong></li>
            <li>Email: support@wrootapp.com</li>
            <li>Address: 5893 HONEYSUCKLE RIDGE ST, LAS VEGAS, NV, 89148, USA</li>
            <li>Phone: [Contact information available upon request]</li>
          </ul>
        </div>
      </Main>
    </>
  );
}

const Main = styled.div`
  max-width: 800px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: var(--s-radius);
  margin: var(--section-margin) auto;
  min-height: var(--section-height);

  .content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    flex-direction: column;
    padding: 20px;
    h4 {
      font-weight: bold;
    }
    h5 {
      font-weight: 600;
    }
    p {
      color: var(--text-light-color);
    }
    
    .effective-date {
      font-size: 1.1rem;
      margin-bottom: 2rem;
      color: var(--text-light-color);
    }
    
    ul {
      margin: 1rem 0;
      padding-left: 1.5rem;
      
      li {
        margin-bottom: 0.5rem;
        color: var(--text-light-color);
      }
    }
    
    .closing {
      margin-top: 2rem;
      font-style: italic;
      font-weight: 500;
      color: var(--primary-color);
    }
  }
`;
